import React, { useState, useMemo } from 'react';
import { useNavigate, Link, useParams } from 'react-router-dom';
import {
  ExpandMore,
  ExpandLess,
  Logout,
  Dashboard,
  AccountCircle,
  DirectionsBoat,
  Description,
  Group,
  SupervisorAccount,
} from '@mui/icons-material';
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Divider,
  Button,
} from '@mui/material';

// Note: We removed the toggle button from this component as it's now handled in the layout

const VesselOwnerSidebar = () => {
  const [expandedMenu, setExpandedMenu] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();

  const toggleMenu = (menuName) => {
    setExpandedMenu(expandedMenu === menuName ? null : menuName);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("admin");
    navigate("/login");
  };
 
  const menuItems = useMemo(() => [
    { name: "Dashboard", path: `/VesselOwnerLayouts/${id}/dashboard`, icon: <Dashboard /> },
    { name: "Profile", path: `/VesselOwnerLayouts/${id}/profile`, icon: <AccountCircle /> },
    {
      name: "Vessels",
      icon: <DirectionsBoat />,
      subMenu: [
        { name: "Add Vessels", path: `/VesselOwnerLayouts/${id}/vessels/addVessel` },
        { name: "Assigned Vessel", path: `/VesselOwnerLayouts/${id}/vessels/assigned` },
        { name: "Vessel List", path: `/VesselOwnerLayouts/${id}/vessels/list` },
      ],
    },
    {
      name: "Contracts",
      icon: <Description />,
      subMenu: [
        { name: "BSM Contracts", path: `/VesselOwnerLayouts/${id}/contracts/bsm` },
        { name: "Vessel Owner Contracts", path: `/VesselOwnerLayouts/${id}/contracts/owners` },
      ],
    },
    {
      name: "Crew",
      icon: <Group />,
      subMenu: [
        { name: "Add Crew", path: `/VesselOwnerLayouts/${id}/crew/add` },
        { name: "Crew List", path: `/VesselOwnerLayouts/${id}/crew/list` },
      ],
    },
    {
      name: "Executive",
      icon: <SupervisorAccount />,
      subMenu: [
        { name: "Add Executive", path: `/VesselOwnerLayouts/${id}/executive/add` },
        { name: "Executive List", path: `/VesselOwnerLayouts/${id}/executive/list` },
      ],
    },
    //  { name: "SeaServiceProfile", path: `/VesselOwnerLayouts/${id}/SeaServiceProfile`, icon: <AccountCircle /> },
  ], [id]);

  return (
    <Box 
      sx={{
        width: 260,
        height: '100%',
        bgcolor: 'white',
        color: 'black',
        boxShadow: 6,
        p: 3,
      }}
    >
      <Typography
        variant="h6"
        fontWeight="bold"
        textAlign="center"
        mb={4}
        sx={{ color: 'black' }}
      >
        Vessel Owner Panel
      </Typography>

      <List component="nav">
        {menuItems.map((item, index) => (
          <Box key={index}>
            {item.subMenu ? (
              <>
                <ListItemButton
                  onClick={() => toggleMenu(item.name)}
                  sx={{
                    borderRadius: 2,
                    p: 1.5,
                    '&:hover': {
                      bgcolor: 'grey.100',
                      color: 'primary.main',
                      '& svg': { color: 'primary.main' },
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: 'primary.main', minWidth: 36 }}>
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText primary={item.name} />
                  {expandedMenu === item.name ? (
                    <ExpandLess sx={{ color: 'primary.main' }} />
                  ) : (
                    <ExpandMore sx={{ color: 'primary.main' }} />
                  )}
                </ListItemButton>
                <Collapse in={expandedMenu === item.name} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding sx={{ pl: 3 }}>
                    {item.subMenu.map((subItem, subIndex) => (
                      <ListItemButton
                        key={subIndex}
                        component={Link}
                        to={subItem.path}
                        sx={{
                          borderRadius: 2,
                          px: 2,
                          py: 1,
                          '&:hover': {
                            bgcolor: 'grey.400',
                          },
                          color: 'black',
                        }}
                      >
                        <ListItemText primary={subItem.name} />
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              </>
            ) : (
              <ListItemButton
                component={Link}
                to={item.path}
                sx={{
                  borderRadius: 2,
                  p: 1.5,
                  '&:hover': {
                    bgcolor: 'grey.100',
                    color: 'primary.main',
                    '& svg': { color: 'primary.main' },
                  },
                }}
              >
                <ListItemIcon sx={{ color: 'primary.main', minWidth: 36 }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.name} />
              </ListItemButton>
            )}
          </Box>
        ))}

        <Divider sx={{ my: 2 }} />

        <Button
          fullWidth
          startIcon={<Logout />}
          onClick={handleLogout}
          sx={{
            color: 'red',
            borderRadius: 2,
            p: 1.5,
            textAlign: 'left',
            justifyContent: 'flex-start',
            '&:hover': {
              bgcolor: 'error.main',
              color: 'white',
            },
          }}
        >
          Logout
        </Button>
      </List>
    </Box>
  );
};

export default VesselOwnerSidebar;